import { C, Panel, Table, Td, Chip, Serif, Label } from "./ui";
import { LEAD_STAGES, LEADS } from "./adminData";

const stageColor = { "New lead": C.slate, "Link opened": C.navy, "Info provided": C.amber, "Debit order": "#7A5AF8", "Activated": C.green };

export default function Leads() {
  const max = Math.max(...LEAD_STAGES.map((s) => s.count));
  return (
    <div>
      <Label>Acquisition</Label>
      <Serif size={26} style={{ marginTop: 4, marginBottom: 6 }}>Leads funnel</Serif>
      <div style={{ fontSize: 12, color: C.slate, marginBottom: 18 }}>Reseller funnel — from broker-shared link to active debit-order customer.</div>

      <Panel style={{ marginBottom: 16 }}>
        <Label style={{ marginBottom: 16 }}>Pipeline · this month</Label>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {LEAD_STAGES.map((s) => (
            <div key={s.stage} style={{ display: "flex", alignItems: "center", gap: 12 }} data-testid={`lead-stage-${s.stage.replace(/\s/g, "-").toLowerCase()}`}>
              <div style={{ width: 110, fontSize: 13, color: C.slate, textAlign: "right", flexShrink: 0 }}>{s.stage}</div>
              <div style={{ flex: 1, background: C.cream, borderRadius: 6, height: 30, position: "relative", overflow: "hidden" }}>
                <div style={{ width: `${(s.count / max) * 100}%`, height: "100%", background: stageColor[s.stage], borderRadius: 6, transition: "width 0.4s" }} />
                <span style={{ position: "absolute", left: 10, top: 6, color: "#fff", fontSize: 13, fontWeight: 700, fontFamily: "'JetBrains Mono', monospace" }}>{s.count}</span>
              </div>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 14, fontSize: 12, color: C.slate }}>Conversion (new → active): <b style={{ color: C.green }}>14.3%</b></div>
      </Panel>

      <Label style={{ marginBottom: 10 }}>Recent leads</Label>
      <Table head={["Name", "Agent", "Stage", "Created"]}>
        {LEADS.map((l, i) => (
          <tr key={i} data-testid={`lead-row-${i}`}>
            <Td style={{ fontWeight: 600 }}>{l.name}</Td>
            <Td style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: C.slate }}>{l.agent}</Td>
            <Td><Chip color={stageColor[l.stage]}>{l.stage}</Chip></Td>
            <Td style={{ color: C.slate }}>{l.created}</Td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
